import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UnsavedChangesModalComponent} from './components/unsaved-changes-modal/unsaved-changes-modal.component';
import {MatButtonModule} from "@angular/material/button";
import {MatDialogModule} from "@angular/material/dialog";
import {UnsavedChangesService} from "@tva/ng-migration/shared/services/unsavedChanges.service";
import {SaveBoxComponent} from './components/save-box/save-box.component';
import './shared.downgrades';
import {RedirectToDirective} from "@tva/ng-migration/shared/directives/legacy/redirect-to.directive";

@NgModule({
    declarations: [
        UnsavedChangesModalComponent,
        SaveBoxComponent,
        RedirectToDirective
    ],
    providers: [UnsavedChangesService],
    imports: [
        CommonModule,
        MatButtonModule,
        MatDialogModule
    ],
  exports: [
    SaveBoxComponent,
    RedirectToDirective
  ]
})
export class SharedModule {
}
